import React from "react";

import { Card } from "react-bootstrap";

import { customDataSource } from "../helpers/gridHandler";
import withRouter from '../helpers/withRouter';

import 'devextreme/data/odata/store';
import DataGridBase from "./DataGridBase";

class noticesByInstance extends React.Component {
    render() {  
        return (
          <Card className="rounded-4">
          <Card.Body>
            <Card.Title>
                Historic Notices by Instance ({global.config.dashboard.range} Days)
            </Card.Title>
            <Card.Subtitle>
              Number of Active User Logins by instance for the selected range
            </Card.Subtitle>
            <DataGridBase
            id="gridContainer"
            groupedNotices={true}
            dataSource={customDataSource(global.config.backend.baseURI + "/api/Statistic/GetCommunicatedNoticesByInstanceRange", "")}            
            />
          </Card.Body>
        </Card>
        );
    }
}

export default withRouter(noticesByInstance);